const makeEmptyArray = (length: number): undefined[] => [...Array(length)];

export default makeEmptyArray;
